import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import Card from './index.js';
import '../../style/core/base/font-awesome.min.scss';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "card-卡片"
    }}>{`Card 卡片`}</h1>
    <p>{`通用卡片组件`}</p>

    <Playground __position={0} __code={'<Card header={<h1>hello</h1>}>\n  <span>this is card component</span>\n</Card>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Card,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Card header={<h1>hello</h1>} mdxType="Card">
    <span>this is card component</span>
  </Card>
    </Playground>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`属性名`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`名称`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`类型`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`默认值`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`header`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`头部信息`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`-`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`bodyStyle`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`内容区样式`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`-`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      